import { render, staticRenderFns } from "./SettingPage.vue?vue&type=template&id=71383f7c&scoped=true&"
import script from "./SettingPage.vue?vue&type=script&lang=js&"
export * from "./SettingPage.vue?vue&type=script&lang=js&"
import style0 from "./SettingPage.vue?vue&type=style&index=0&id=71383f7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71383f7c",
  null
  
)

export default component.exports